import React, {Component} from "react"
import {RouteComponentProps} from "react-router-dom"
import * as PropTypes from "prop-types"

import history from "@irati/utils/history"
import Loading from "@irati/ui/src/Loading"
import RewardService from "@irati/reward/apollo/Reward"
import {rewardTracking} from "@irati-tracking/reward"
import {hangPromise} from "@irati/utils/promise"
import ErrorText from "@irati/ui/src/ErrorText"
import {Poll, Recognition} from "@irati/types"
import RecognitionService from "@irati/recognition/services/Recognition"
import {injectIntl, InjectIntl} from "@irati/utils/lang"

interface Match {
  rewardOrderId: string,
  recipientsCount: string,
  costTotal: string,
  rewardHeader: string,
  entityId: string,
  entityType: string
}

interface Props extends RouteComponentProps<Match>, InjectIntl {}

interface State {
  completingPayment: Promise<void>,
  error: string | null
}

class CompletePayment extends Component<Props, State> {
  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  state: State = {
    completingPayment: hangPromise(),
    error: null
  }

  componentDidMount() {
    const {formatMessage} = this.props
    const {rewardOrderId, entityId, entityType} = this.props.match.params

    const completingPayment = RewardService.confirmRewardPaymentOrder(rewardOrderId)
      .then(
        (): Promise<Poll | Recognition | void> => {
          if (entityId && entityType === "poll") {
            return RecognitionService.updatePollWithRewardId(entityId, rewardOrderId)
          }
          return RecognitionService.updateRecognitionWithRewardId(entityId, rewardOrderId)
        }
      )
      .then(async() => {
        const {recipientsCount, costTotal, rewardHeader} = await this.getTrackingInfos()
        rewardTracking.rewardsTabAddRewardSuccess(recipientsCount, costTotal, rewardHeader)
        history.push({pathname: `/reward/success/${rewardOrderId}`}, this.context)
      })
      .catch(() => {
        this.setState({error: formatMessage({id: "reward.genericPaymentError"})})
      })
    this.setState({completingPayment})
  }

  getTrackingInfos = async() => {
    const {rewardOrderId} = this.props.match.params
    const rewardOrder = await RewardService.getRewardOrder(rewardOrderId)

    return {
      recipientsCount: rewardOrder.recipients.results.length,
      costTotal: rewardOrder.costTotal,
      rewardHeader: rewardOrder.reward.header
    }
  }

  render() {
    const {completingPayment, error} = this.state
    return <Loading load={completingPayment}>{error && <ErrorText>{error}</ErrorText>}</Loading>
  }
}

export default injectIntl(CompletePayment)
